import { Controller } from '@hotwired/stimulus'
import * as Turbo from '@hotwired/turbo'

export default class extends Controller {
  static targets = ['checkbox', 'partySize', 'charterType']
  static values = { url: String }

  connect() {
    this.debounceTimeout = null
  }

  update() {
    this.fetchTotal()
  }

  debouncedUpdate() {
    clearTimeout(this.debounceTimeout)
    this.debounceTimeout = setTimeout(() => {
      this.fetchTotal()
    }, 300)
  }

  fetchTotal() {
    const selectedIds = this.checkboxTargets
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.value)

    const partySize = this.hasPartySizeTarget ? this.partySizeTarget.value : 1
    const charterTypeId = this.hasCharterTypeTarget ? this.charterTypeTarget.value : null

    const formData = new FormData()
    selectedIds.forEach(id => formData.append('add_on_item_ids[]', id))
    formData.append('party_size', partySize)
    if (charterTypeId) {
      formData.append('private_charter_type_id', charterTypeId)
    }

    fetch(this.urlValue, {
      method: 'POST',
      headers: {
        'Accept': 'text/vnd.turbo-stream.html'
      },
      body: formData
    })
      .then(response => response.text())
      .then(html => {
        Turbo.renderStreamMessage(html)
      })
  }
}
